export default __webpack_public_path__ + "static/11-ddf03375996ce3fcba9a83e3811550aa.jpg";